<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;800&display=swap');

* {
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

a :hover {
  text-decoration: none !important;
}

a:link {
  text-decoration: none !important;
}

a:visited {
  text-decoration: none !important;
}

a:hover {
  text-decoration: none !important;
}

a:active {
  text-decoration: none !important;
}

.landing-page-section {
  overflow: hidden;
}

section.menu {
  display: flex;
  width: 100vw;
  max-width: 100vw;
  margin-left: calc(50% - 50vw);
}

.menu-box {
  display: none;
}

.header-desktop {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 20px 20px 20px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 300;
  width: 100%;
  height: 100px;
  flex-direction: row;
}

.header-desktop .menu-desktop {
  display: flex;
  width: 100%;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  max-width: 1140px;
}

.header-desktop .nav-left {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  width: 74.33%;
}

.header-desktop .nav-right {
  display: flex;
  justify-content: end;
}

.header-desktop .logo img {
  height: 50px;
  width: 100%;
  margin: 0px 80px 0px 0px;
}

.header-desktop .navbar {
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-desktop .navbar a {
  font-size: 16px;
  font-family: "Montserrat";
  font-weight: 600;
  color: #3D4053;
  padding: 0 22px;
  transition: 200ms ease all;
}

.header-desktop .fa {
  color: #3D4053;
  padding-right: 22px;
}

.header-desktop .dropdown {
  position: relative;
  display: inline-block;
}

.header-desktop .dropdown .dropdown-title {
  margin-right: 11px;
  padding: 0 0 0 22px;
}

.header-desktop .dropdown-content {
  display: none;
  position: absolute;
  background-color: white;
  z-index: 1;
  min-width: 250px;
  padding: 10px;
  border-radius: 0px 0px 10px 10px;
}

.header-desktop .dropdown-content a {
  color: #3D4053;
  display: block;
  text-align: left;
  padding: 8px 8px;
}

.header-desktop .dropdown:hover .dropdown-content {
  display: block;
}


.header-desktop .dropdown:hover .dropbtn {
  background-color: #3e8e41;
}

.nav-right .navbar .free-trial-desktop {
  padding: 0px;
}

.nav-right button {
  color: #ffffff;
  font-family: "Montserrat";
  font-weight: 600;
  background-color: #FE3CA6;
  border: none;
  border-radius: 10px;
  width: 131px;
  height: 50px;
  vertical-align: middle;
  box-shadow: 0 2px 25px rgb(254 60 166 / 47%);
  text-transform: uppercase;
}

@media (min-width: 1024px) and (max-width: 1071px) {
  .header-desktop .navbar a {
    font-size: 16px;
    font-family: "Montserrat";
    font-weight: 600;
    color: #3D4053;
    padding: 0 10px;
    transition: 200ms ease all;
  }

  .header-desktop .dropdown .dropdown-title {
    margin-right: 11px;
    padding: 0 0 0 10px;
  }

  .header-desktop .fa {
    color: #3D4053;
    padding-right: 10px;
  }
}

@media (min-width: 1072px) and (max-width: 1120px) {
  .header-desktop .navbar a {
    font-size: 16px;
    font-family: "Montserrat";
    font-weight: 600;
    color: #3D4053;
    padding: 0 17px;
    transition: 200ms ease all;
  }

  .header-desktop .dropdown .dropdown-title {
    margin-right: 11px;
    padding: 0 0 0 17px;
  }

  .header-desktop .fa {
    color: #3D4053;
    padding-right: 17px;
  }
}

@media (min-width: 320px) and (max-width: 768px) {
  .header-desktop {
    display: none;
  }

  .menu-box {
     
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding: 0;
    padding-right: 20px;
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin: 0;
    background-color: #adf6dd;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 300;
    width: 100%;
    font-family: 'Montserrat';
    font-weight: 600;
    color: #37474f;
  }

  .menu-box .menu-links {
    display: flex;
    justify-content: space-evenly;
    width: 600px;
  }

  .menu .menu-links a {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 300;
    font-size: 26px;
    line-height: 46px;
    color: #ffffff;
    text-decoration: none;
  }

  .menu-logo {
    height: 40px;
    width: 200px;
    display: flex;
    align-items: flex-end;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: transparent;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 300;
    width: 100%;
  }

  .header__menu {
    margin-top: -9px;
  }

  .header__logo {
    width: 200px;
    height: 29px;
    padding: 0 10px;
  }

  .header__buttons {
    display: flex;
  }

  .nav-container {
    display: flex;
    z-index: 99;
  }

  .hamburger {
    display: flex;
    flex-direction: column;
    height: 25px;
    justify-content: space-between;
    margin: 1em 1em;
    z-index: 3;
  }

  .hamburger:hover {
    cursor: pointer;
  }

  .nav-bar {
    width: 32px;
    height: 3px;
    background-color: #adf6dd !important;
    transition: 500ms ease-in-out all;
  }

  .nav-container {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .menu-container {
    display: flex;
    justify-content: center;
    width: 400px;
    background-color: #37474f;
    height: 100px;
  }

  .dropdown {
    position: absolute !important;
    background: #fff 0% 0% no-repeat padding-box;
    opacity: 1;
    display: flex;
    flex-direction: column;
    width: 30%;
    padding: 15px;
    display: none;
  }

  .dropdown-active {
    right: 0;
    top: 65px;
    height: auto;
    padding-top: 10px;
    padding-right: 30px;
    padding-left: 30px;
    border: none !important;
    text-align: left;
  }

  .dropdown p {
    font-size: 26px;
    font-family: "Montserrat";
    color: #37474f;
    margin: 15px;
    transition: 200ms ease all;
    outline: none;
    border: none;
  }

  .dropdown .sub-item p {
    margin-left: 25px;
    font-size: 22px;
    outline: none;
    border: none;
    text-transform: capitalize;
  }

  .dropdown a:hover {
    border: none !important;
  }

  .dropdown p:hover {
    cursor: pointer;
    border-bottom: none;
  }

  .one-active {
    background-color: #ffffff !important;
    transform: translateY(13px) rotate(45deg);
  }

  .two-active {
    display: none;
  }

  .three-active {
    background-color: #ffffff !important;
    transform: translateY(-9px) rotate(135deg);
  }

  .menu-logo {
    width: 160px;
    background: url(../assets/NI_logo_v2.svg);
    background-repeat: no-repeat;
    background-size: contain;
  }

  .header {
    padding: 10px;
  }
 
  .header__logo {
    width: 100%;
  }

  .header__menu {
    margin-top: 0;
  }

  .dropdown {
    width: 100%;
  }

  .dropdown-active {
    padding-right: 15px;
    padding-left: 15px;
  }

  .dropdown .sub-item p {
    font-size: 16px;
  }
  
  .dropdown p {
    font-size: 16px;
    margin: 10px;
    display: inline-block;
  }

  .dropdown i {
    color: #3D4053;
  }

  .nav-bar {
    background-color: #000 !important;
  } 

  .nav-container .signin-btn-mobile-container {
    display: flex;
    align-items: center;
  }

  .nav-container .signin-btn-mobile {
    width: 110px;
    border-radius: 50px;
    border: none;
    background-color: #FE3CA6;
    color: #fff;
    height: 35px;
    box-shadow: 0 2px 25px rgb(254 60 166 / 47%);
    font-size: 13px;
  }

  .sub-menu {
    display: flex;
    flex-direction: column;
    font-size: 16px;
  }

  .sub-menu .sub-item {
    font-size: 16px;
  }
}
</style>

<template>
  <div>
    <div class="container">
       <div class="menu-box">
        <a href="https://ninjainfluence.com/">
          <div class="menu-logo"></div>
        </a>
        <nav class="nav-container">
          <div class="signin-btn-mobile-container">
            <a href="https://app.ninjainfluence.com/influencers/login">
              <button class="signin-btn-mobile">SIGN IN</button>
            </a>
          </div>
          <div class="hamburger" @click="onDropClick($event)">
            <div class="nav-bar one"></div>
            <div class="nav-bar two"></div>
            <div class="nav-bar three"></div>
          </div>
          <div class="dropdown">

            <a href="#" @click="onAboutClick()">
              <p class="drop-item">About</p>
              <i v-if="!aboutExpand" class="fa">&#61655;</i>
              <i v-if="aboutExpand" class="fa">&#61656;</i>
            </a>
            <div v-if="aboutExpand" class="sub-menu">
              <a class="sub-item" href="https://ninjainfluence.com/our-dna/">
                <p class="drop-item">Our DNA</p>
              </a>
              <a class="sub-item" href="https://ninjainfluence.com/leader/">
                <p class="drop-item">Leadership Team</p>
              </a>
              <a class="sub-item" href="https://ninjainfluence.com/careers/">
                <p class="drop-item">Careers</p>
              </a>
              <a class="sub-item" href="https://ninjainfluence.com/testimonials/">
                <p class="drop-item">Testimonials</p>
              </a>
              <a class="sub-item" href="https://ninjainfluence.com/case-studies/">
                <p class="drop-item">Case Studies</p>
              </a>
            </div>

            <a href="#" @click="onCustomersClick()">
              <p class="drop-item">Customers</p>
              <i v-if="!customersExpand" class="fa">&#61655;</i>
              <i v-if="customersExpand" class="fa">&#61656;</i>
            </a>
            <div v-if="customersExpand" class="sub-menu">
              <a class="sub-item" href="https://app.ninjainfluence.com/retailers/">
                <p class="drop-item">Brands</p>
              </a>
              <a class="sub-item" href="https://app.ninjainfluence.com/influencers/">
                <p class="drop-item">Influencers</p>
              </a>
            </div>

            <a href="https://ninjainfluence.com/blog/">
              <p class="drop-item">Blog</p>
            </a>

            <a href="https://ninjainfluence.com/contact-us">
              <p class="drop-item">Contact</p>
            </a>

            <a href="https://app.ninjainfluence.com/retailers/book">
              <p class="drop-item">Request a Demo</p>
            </a>

            <a href="https://app.ninjainfluence.com/app/login">
              <p class="drop-item">SIGN IN</p>
            </a>
          </div>
        </nav>
      </div>
    </div>

    <div class="header-desktop">
      <div class="menu-desktop">
        <div class="nav-left">
          <a href="https://ninjainfluence.com/" class="header__logo logo">
            <img src="../assets/NI_logo_v2.svg" alt="logo" />
          </a>

          <div class="navbar">
            <div class="dropdown">
              <a href="#" class="dropdown-title">About</a>
              <i class="fa">&#61655;</i>

              <div class="dropdown-content">
                <a href="https://ninjainfluence.com/our-dna/">Our DNA</a>
                <a href="https://ninjainfluence.com/leader/">Leadership Team</a>
                <a href="https://ninjainfluence.com/careers/">Careers</a>
                <a href="https://ninjainfluence.com/testimonials/">Testimonials</a>
                <a href="https://ninjainfluence.com/case-studies/">Case Studies</a>
              </div>
            </div>
            <div class="dropdown">
              <a href="#" class="dropdown-title">Customers</a>
              <i class="fa">&#61655;</i>

              <div class="dropdown-content">
                <a href="https://app.ninjainfluence.com/retailers/">Brands</a>
                <a href="https://app.ninjainfluence.com/influencers/">Influencers</a>
              </div>
            </div>

            <a href="https://ninjainfluence.com/blog">Blog</a>
            <a href="https://ninjainfluence.com/contact-us">Contact</a>
            <a href="https://app.ninjainfluence.com/retailers/book">Request a Demo</a>
          </div>
        </div>

        <div class="nav-right">
          <div class="navbar">
            <a href="https://app.ninjainfluence.com/app/login" class="signin-btn-desktop">SIGN IN</a>
            <a href="/retailers/book" class="free-trial-desktop"><button>Free Trial</button></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "MainMenu",
  data() {
    return {
      aboutExpand: false,
      customersExpand: false,
    }
  },
  props: {},

  components: {},

  methods: {
    ctaLogin: function () {
      mixpanel.track("App", { category: "Common", label: "LandingPage_Cta" });

      // router.push({ name: "Login" });
    },
    onDropClick: function (e) {
      console.log("e", e);
      const dropdown = e.currentTarget.nextElementSibling;
      const burgerBars = [].slice.call(e.currentTarget.children);
      const dropdown_div = document.querySelector(".dropdown");

      if (!dropdown.classList.contains("dropdown-active")) {
        dropdown_div.style.display = "flex";

        dropdown.classList.add("dropdown-active");
        burgerBars[0].classList.add("one-active");
        burgerBars[1].classList.add("two-active");
        burgerBars[2].classList.add("three-active");
      } else if (dropdown.classList.contains("dropdown-active")) {
        dropdown_div.style.display = "none";

        dropdown.classList.remove("dropdown-active");
        burgerBars[0].classList.remove("one-active");
        burgerBars[1].classList.remove("two-active");
        burgerBars[2].classList.remove("three-active");
      }
    },
    onAboutClick: function() {
      this.aboutExpand = !this.aboutExpand;
      console.log(this.aboutExpand)
    },
    onCustomersClick: function() {
      this.customersExpand = !this.customersExpand;
      console.log(this.customersExpand)
    },

  },
};
</script>
